<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.diamant_settings.form.hostname')"
            :is-required="true"
            :error="errorsData.hostname"
            :hint="__('settings.diamant_settings.form.hostname_hint')"
        >
            <DInput
                id="hostname"
                v-model="form.hostname"
                :placeholder="__('settings.diamant_settings.form.hostname')"
                :is-valid="isFormFieldValid('hostname')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.diamant_settings.form.username')"
            :is-required="true"
            :error="errorsData.username"
            :hint="__('settings.diamant_settings.form.username_hint')"
        >
            <DInput
                id="username"
                v-model="form.username"
                :placeholder="__('settings.diamant_settings.form.username')"
                :is-valid="isFormFieldValid('username')"
                maxlength="10"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.diamant_settings.form.password')"
            :is-required="diamantSettings === null"
            :error="errorsData.password"
            :hint="__('settings.diamant_settings.form.password_hint')"
        >
            <DInput
                id="password"
                v-model="form.password"
                :placeholder="__('settings.diamant_settings.form.password')"
                type="password"
                :is-valid="isFormFieldValid('password')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.diamant_settings.form.tenant_id')"
            :is-required="true"
            :error="errorsData.tenant_id"
            :hint="__('settings.diamant_settings.form.tenant_id_hint')"
        >
            <DInput
                id="tenant_id"
                v-model="form.tenant_id"
                :placeholder="__('settings.diamant_settings.form.tenant_id')"
                :is-valid="isFormFieldValid('tenant_id')"
                type="string"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.diamant_settings.form.send_ledger_account')"
            :error="errorsData.send_ledger_account"
            :hint="__('settings.diamant_settings.form.send_ledger_account_hint')"
        >
            <DSwitch
                id="send_ledger_account"
                v-model="form.send_ledger_account"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormRow
            v-if="form.send_ledger_account"
            :is-required="true"
            :label="__('settings.diamant_settings.form.ledger_account_inland')"
            :error="errorsData.ledger_account_inland"
            :hint="__('settings.diamant_settings.form.ledger_account_inland_hint')"
        >
            <DInput
                id="ledger_account_inland"
                v-model="form.ledger_account_inland"
                :is-valid="isFormFieldValid('ledger_account_inland')"
            />
        </DFormRow>
        <DFormRow
            v-if="form.send_ledger_account"
            :is-required="true"
            :label="__('settings.diamant_settings.form.ledger_account_foreign')"
            :error="errorsData.ledger_account_foreign"
            :hint="__('settings.diamant_settings.form.ledger_account_foreign_hint')"
        >
            <DInput
                id="ledger_account_inland"
                v-model="form.ledger_account_foreign"
                :is-valid="isFormFieldValid('ledger_account_foreign')"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-if="connectionStatus === 'successful'"
                    style="color: green;"
                >
                    {{ __('settings.diamant_settings.connection_successful') }}
                </div>
                <div
                    v-if="connectionStatus === 'unsuccessful'"
                    style="color: red;"
                >
                    {{ __('settings.diamant_settings.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.diamant_settings.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
        </DRow>
        <DFormRow
            :label="__('settings.diamant_settings.form.db_host')"
            :is-required="true"
            :error="errorsData.db_host"
            :hint="__('settings.diamant_settings.form.db_host_hint')"
        >
            <DInput
                id="db_host"
                v-model="form.db_host"
                :is-valid="isFormFieldValid('db_host')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.diamant_settings.form.db_port')"
            :is-required="true"
            :error="errorsData.db_port"
            :hint="__('settings.diamant_settings.form.db_port_hint')"
        >
            <DInput
                id="db_port"
                v-model="form.db_port"
                :is-valid="isFormFieldValid('db_port')"
                type="number"
                max="65535"
                min="0"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.diamant_settings.form.db_username')"
            :is-required="true"
            :error="errorsData.db_username"
            :hint="__('settings.diamant_settings.form.db_username_hint')"
        >
            <DInput
                id="db_username"
                v-model="form.db_username"
                :is-valid="isFormFieldValid('db_username')"
                maxlength="12"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.diamant_settings.form.db_password')"
            :is-required="diamantSettings === null"
            :error="errorsData.db_password"
            :hint="__('settings.diamant_settings.form.db_password_hint')"
        >
            <DInput
                id="db_password"
                v-model="form.db_password"
                :placeholder="__('settings.diamant_settings.form.password')"
                type="password"
                :is-valid="isFormFieldValid('db_password')"
                maxlength="255"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-if="dbConnectionStatus === 'successful'"
                    style="color: green;"
                >
                    {{ __('settings.diamant_settings.connection_successful') }}
                </div>
                <div
                    v-if="dbConnectionStatus === 'unsuccessful'"
                    style="color: red;"
                >
                    {{ __('settings.diamant_settings.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.diamant_settings.check_database_connection')"
                    :disabled="isInLoadingState"
                    @click="checkDbConnection"
                />
            </DCol>
        </DRow>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script>

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

export default {
    name: 'DiamantSettingsForm',
    components: { DConnectionErrorModal },
    props: {
        diamantSettings: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                hostname: this.diamantSettings?.hostname ?? null,
                username: this.diamantSettings?.username ?? null,
                password: this.diamantSettings?.password ?? null,
                tenant_id: this.diamantSettings?.tenant_id ?? null,
                db_host: this.diamantSettings?.db_host ?? null,
                db_port: this.diamantSettings?.db_port ?? null,
                db_username: this.diamantSettings?.db_username ?? null,
                db_password: this.diamantSettings?.db_password ?? null,
                send_ledger_account: this.diamantSettings?.send_ledger_account ?? false,
                ledger_account_inland: this.diamantSettings?.ledger_account_inland ?? null,
                ledger_account_foreign: this.diamantSettings?.ledger_account_foreign ?? null,
                finance_system: 'diamant'
            }),
            connectionStatus: '',
            dbConnectionStatus: '',
            errorsData: this.errors,
            connectionException: null
        }
    },
    watch: {
        errors: function (errors) {
            this.errorsData = errors
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        },
        checkConnection () {
            this.errorsData = {}
            const self = this
            self.connectionException = null
            window.axios.post(this.$route('settings.finance-system-settings.check-diamant', this.form))
                .then(function () {
                    self.connectionStatus = 'successful'
                })
                .catch(function (error) {
                    self.connectionStatus = 'unsuccessful'
                    if (error.response.data.error !== undefined) {
                        self.error = error.response.data.error
                    }
                    if (error.response.data.errors !== undefined) {
                        self.errorsData = error.response.data.errors

                        for (const key in self.errorsData) {
                            if (typeof self.errorsData[key] === 'object') {
                                self.errorsData[key] = self.errorsData[key][0]
                            }
                        }
                    }

                    if (error?.response.data.exception !== undefined) {
                        self.connectionException = error.response.data.exception
                    }
                })
        },
        checkDbConnection () {
            this.errorsData = {}
            const self = this
            self.connectionException = null
            window.axios.post(this.$route('settings.finance-system-settings.db-check-diamant', this.form))
                .then(function (response) {
                    self.dbConnectionStatus = 'successful'
                })
                .catch(function (error) {
                    self.dbConnectionStatus = 'unsuccessful'

                    if (error.response.data.error !== undefined) {
                        self.error = error.response.data.error
                    }
                    if (error.response.data.errors !== undefined) {
                        self.errorsData = error.response.data.errors

                        for (const key in self.errorsData) {
                            if (typeof self.errorsData[key] === 'object') {
                                self.errorsData[key] = self.errorsData[key][0]
                            }
                        }
                    }
                    if (error?.response.data.exception !== undefined) {
                        self.connectionException = error.response.data.exception
                    }
                })
        },
        closeErrorCheckModal () {
            this.connectionException = null
        }
    }
}
</script>

<style lang="scss" scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}
</style>
